// src/components/layout/Header/FunctionalLayer/SettingsUnitSelector.jsx

'use client';


import { useState } from 'react';
import { Button, Menu, MenuItem, ListItemText, ListItemIcon } from '@mui/material';
import {
  ArrowDropDown as ArrowDropDownIcon,
  SquareFoot as SquareFootIcon,
  Straighten as StraightenIcon,
  Sailing as SailingIcon,
} from '@mui/icons-material';
import { usePreferences } from '@/contexts/ShopPreferences.context'; // Adjust the path as needed


export default function SettingsUnitSelector() {

  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);

  const { unitSystem, setUnitSystem } = usePreferences();

  const unitsDisplay = {
    SI: 'm/cm',
    USC: 'ft/in',
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleUnitSelection = (unit) => {
    setUnitSystem(unit);
    handleClose();
  };

  return (
    <>
      <Button
        id="unit-button"
        aria-label="Unit selection"
        aria-controls={open ? 'unit-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={open ? 'true' : undefined}
        onClick={handleClick}
        startIcon={<SquareFootIcon />}
        endIcon={<ArrowDropDownIcon />}
      >
        {unitsDisplay[unitSystem]}
      </Button>
      <Menu
        id="unit-menu"
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'unit-button',
        }}
      >
        <MenuItem onClick={() => handleUnitSelection('SI')}>
          <ListItemIcon>
            <StraightenIcon />
          </ListItemIcon>
          <ListItemText>Metres/Centimeters</ListItemText>
        </MenuItem>

        <MenuItem onClick={() => handleUnitSelection('USC')}>
          <ListItemIcon>
            <SailingIcon />
          </ListItemIcon>
          <ListItemText>Feet/Inches</ListItemText>
        </MenuItem>
      </Menu>
    </>
  );
}
